<template>
  <main id="thankyou-page">
    <div id="nongkrong-bareng-barry-thankyou-page">
      <div class="container-nongkrong">
        <div class="content-wrapper">
          <div class="card-section">
            <div class="icon-barry-face">
              <img :src="base_url + '/images/icon-barry-face.svg'" alt="Icon Barry Face">
            </div>
            <h2>Makasi BradSis!</h2>
            <p>Data kamu sudah kami terima. Buat yang kepilih, bakal kita hubungi langsung lewat Instagram <strong><a style="color: #fff;" href="https://www.instagram.com/honda.community" target="_blank">@honda.community</a></strong> <br> Satu gas, sejuta tawa. Sampai ketemu di jalur!</p>
          </div>

          <a :href="app_url" class="btn mx-2 btn-red">Home</a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { isMobile } from "mobile-device-detect";

export default {
  data() {
    return {
      base_url:base_url,
      app_url: app_url,
      api_url: api_url,
      main_site_url: main_site_url,
      mobile: false,
    };
  },
  created() {
    this.mobile = isMobile;

    if (localStorage.getItem('nongkrong-bareng-barry-touring') != null){
      setTimeout(function() { 
          let submission = JSON.parse(localStorage.getItem('nongkrong-bareng-barry-touring'));
  
          let track = {
            "event": "successFormSubmissionEvent",
            'formId': submission.data.form_id,
            "title": "Honda Community Event", //exp="Layanan Bengkel",
            "subtopic": "Jalur Tawa-Nongkrong Bareng Barry Williem", //exp="AHASS Booking Service",
            "selectedProvince": submission.data.province ? submission.data.province.name : null,
            "selectedCity": submission.data.city ? submission.data.city.name : null,
            "motorCategory": submission.data.product_category ? submission.data.product_category.title : null,
            "motorVariant": submission.data.product ? submission.data.product.title : null,
            "manufactureYear": submission.data.year,
            "communityName": submission.data.community_name,
            "option": `IG:${submission.data.instagram}|MotorBrand:${submission.data.brand_motor}|JoinCommunity:${submission.data.community_joined_year}|Touring:${submission.data.has_joined_touring}`,
        }
        dataLayer.push(track);
        localStorage.removeItem('nongkrong-bareng-barry-touring');
      }, 2000);
    } else {
      this.$router.push({ path: '/community/touring/jalur-tawa' });
    }
  },
  methods: {
  },
};
</script>
<style lang="scss">
  #nongkrong-bareng-barry-thankyou-page {
    background-image: url('https://ik.imagekit.io/zlt25mb52fx/ahmcdn/uploads/page/banner/background-nongkrong-bareng-barry-13062025-020636.webp');
    background-size: cover;
    background-position: center;
    // background-repeat: no-repeat;
    min-height: 100dvh;
  }
</style>
<style scoped lang="scss">
.container-nongkrong {
  max-width: 500px;
  margin: 0 auto;
}
.btn-red {
  background-color: red;
  color: white;
  margin-top: 25px;
}
#nongkrong-bareng-barry-thankyou-page {
  font-family: Manrope;

  .content-wrapper {
    width: 100%;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .card-section {
    position: relative;
    background-image: url('https://ik.imagekit.io/zlt25mb52fx/ahmcdn/uploads/page/banner/background-barry-red-17062025-120819.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    padding: 100px 50px 80px 50px;

    .icon-barry-face {
      position: absolute;
      top: -110px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;

      img {
        width: 100%;
        height: auto;
      }
    }

    h2 {
      margin-bottom: 20px;
    }

    p {
      color: #fff;
    }

    ul {
      list-style-type: disc;
      margin-left: 20px;
    }
  }

  .btn-submit {
    margin: 40px 0;
  }
  .btn {
    width: 161px;
  }
  .btn-red {
    background: #e61b33;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
  }
  @media (max-width: 768px) {
    .btn {
      width: 120px;
    }
  }
  @media (max-width: 576px) {
    .content-wrapper {
      padding: 0 20px;
    }

    .card-section {
      .icon-barry-face {
        top: -100px;
      }
    }
  }
}
</style>
